import * as React from 'react'
import { useLocation } from 'react-router-dom'

const Component: React.FC = () => {
  const { pathname } = useLocation()
  React.useEffect(() => {
    // @ts-ignore
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname])
  return null
}

export default Component
